<template>
  <div class="status-change-suspend-not-audit-final-reject">
    <el-form-item label="驳回理由">
      <el-input v-model="form.auditRemark"
                type="textarea"
                maxlength="200"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'StatusChangeSuspendNotAuditFinalReject',
  props: {
    applyId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      form: {
        auditRemark: ''
      }
    }
  },
  methods: {
    getAuditInfo () {
      return new Promise(resolve => {
        if (!this.form.auditRemark) {
          this.$confirm('未填写驳回理由，确认继续吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve(this.resolveAudit(this.form))
          }).catch(() => {})
        } else {
          resolve(this.resolveAudit(this.form))
        }
      })
    },
    resolveAudit (form) {
      return {
        url: '/workspace/manager/status/change/auditSuspend/final/submitRejected',
        data: this.$qs.stringify(this.$extend({
          postId: this.applyId
        }, form))
      }
    }
  }
}
</script>
